export default "__VITE_ASSET__k0gW2eyA__"